module.exports = __webpack_public_path__ + "static/media/microArray.85e8bdd4.svg";